module.exports = __webpack_public_path__ + "img/hoverBox4.342c4eee.png";